import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import VExportPaymentService from '../../../../Services/VExportPaymentService';
import VoidAndReissueParamsItem from '../../../../Domain/VoidAndReissueParamsItem';

export default class VoidAndReissueWindowDescription {
  static titleForCreate = 'Void & Reissue';
  static titleForEdit = 'Void & Reissue';
  static finishButtonLabel = 'Void & Reissue';
  static itemType = VoidAndReissueParamsItem;
  static serviceFunction = (edited) => VExportPaymentService.VoidAndReissue(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void & Reissue process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Surcharge',
          label: 'Surcharge',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        { fieldName: 'Reason', label: 'Reason', className: 'col-12', type: InputTypesEnum.TextBox },
      ],
    },
  ];
}
